import $ from 'jquery';
import contentBlocker from './content-blocker';
import HtmlHelper from './html-helper';
import TweenLite from 'gsap/TweenLite';

export default class ModalController {

    static getInstance() {
        if (ModalController.instance === null) {
            ModalController.instance = new ModalController();
        }
        return ModalController.instance;
    }

    constructor() {
        this.openedModal = null;
        this.modalOverlay = document.getElementById('modal-overlay');
        this.overlayTween = TweenLite.fromTo(
            this.modalOverlay,
            0.3,
            {opacity: '0', display: 'none', paused: true},
            {opacity: '1', display: 'block'}
        );
        this.setOuterHandler();
    }


    setOuterHandler() {
        $(document).on('click touchstart', this._outerClickHandle.bind(this));
    }

    _outerClickHandle(e) {
        if (this.openedModal) {
            if (this.openedModal.getElement().contains(e.target)) {
                if (!this.openedModal.getWrapperElement().contains(e.target)) {
                    this.closeOpened();
                }
            }
        }
    }

    close(modal) {
        if (this.openedModal && this.openedModal === modal) {
            this._beforeClose();
            modal.onClose();
            this.openedModal = null
        }
    }

    swap(modal, swapModal) {
        if (this.openedModal && this.openedModal === modal) {
            modal.onClose(true).then(() => {
                swapModal.onOpen();
                this.openedModal = swapModal;
            });
        }
    }

    open(modal) {
        if (this.openedModal) {
            if (this.openedModal !== modal) {
                this.swap(this.openedModal, modal);
            }
            return;
        }

        modal.onOpen();
        this.openedModal = modal;
        this._afterOpen();
    }

    _afterOpen() {
        contentBlocker.block('modal');
        this.overlayTween.play();
        this.openedModal.getElement().style['-webkit-overflow-scrolling'] = 'touch'
    }

    _beforeClose() {
        contentBlocker.unblock('modal');
        this.overlayTween.reverse();
        this.openedModal.getElement().style['-webkit-overflow-scrolling'] = 'auto'
    }

    closeOpened() {
        if (this.openedModal) {
            this.close(this.openedModal);
        }
    }
}

ModalController.instance = null;



// WEBPACK FOOTER //
// ./app/general/js/modal-controller.js